// import strings from '../../../Localization/Localization';

export const form = {
  formKey: "alphalinkDataRechargeSearch",
  fields: [
  ]
}
